import axios from 'axios'
import store from '@/store'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

function getHeaders () {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Token ${store.getters.getToken}`
  }
}

export const golfConveniosAPI = {
  // ========== TIPOS DE CONVENIOS ==========

  listaTipos (params = {}) {
    return axios.get(`${API_BASE_URL}/convenio-types/`, {
      headers: getHeaders(),
      params
    })
  },

  tiposActivos () {
    return axios.get(`${API_BASE_URL}/convenio-types/`, {
      headers: getHeaders()
    })
  },

  tiposConvenios () {
    return axios.get(`${API_BASE_URL}/course-agreements/agreement-type-choices/`, {
      headers: getHeaders()
    })
  },

  camposDisponibles () {
    return axios.get(`${API_BASE_URL}/convenio-types/available_courses/`, {
      headers: getHeaders()
    })
  },

  // Cargar usuarios normales (residents)
  cargarResidents () {
    return axios.get(`${API_BASE_URL}/residents/all`, {
      headers: getHeaders()
    })
  },

  // Cargar todos los CCSLP users
  cargarCCSLPUsers (limit = 500, offset = 0) {
    return axios.get(`${API_BASE_URL}/ccslp/users/`, {
      headers: getHeaders(),
      params: { limit, offset }
    })
  },

  // Buscar CCSLP users por nombre
  buscarCCSLPUsers (nombre, limit = 50, offset = 0) {
    return axios.get(`${API_BASE_URL}/ccslp/users/`, {
      headers: getHeaders(),
      params: { name: nombre, limit, offset }
    })
  },

  getTipo (id) {
    return axios.get(`${API_BASE_URL}/convenio-types/${id}/`, {
      headers: getHeaders()
    })
  },

  crearTipo (data) {
    return axios.post(`${API_BASE_URL}/convenio-types/`, data, {
      headers: getHeaders()
    })
  },

  editarTipo (id, data) {
    return axios.patch(`${API_BASE_URL}/convenio-types/${id}/`, data, {
      headers: getHeaders()
    })
  },

  eliminarTipo (id) {
    return axios.delete(`${API_BASE_URL}/convenio-types/${id}/`, {
      headers: getHeaders()
    })
  },

  // ========== CONVENIOS ==========

  listaConvenios (params = {}) {
    return axios.get(`${API_BASE_URL}/convenios/`, {
      headers: getHeaders(),
      params
    })
  },

  conveniosActivos () {
    return axios.get(`${API_BASE_URL}/convenios/activos/`, {
      headers: getHeaders()
    })
  },

  getConvenio (id) {
    return axios.get(`${API_BASE_URL}/convenios/${id}/`, {
      headers: getHeaders()
    })
  },

  // User se inscribe a sí mismo
  inscribirseConvenio (data) {
    return axios.post(`${API_BASE_URL}/convenios/inscribirse/`, data, {
      headers: getHeaders()
    })
  },

  // Admin inscribe un User normal
  inscribirUserConvenio (data) {
    return axios.post(`${API_BASE_URL}/convenios/inscribir-user/`, data, {
      headers: getHeaders()
    })
  },

  // Admin inscribe un CCSLPUser
  inscribirCCSLPConvenio (data) {
    return axios.post(`${API_BASE_URL}/convenios/inscribir-ccslp/`, data, {
      headers: getHeaders()
    })
  },

  crearConvenio (data) {
    return axios.post(`${API_BASE_URL}/convenios/`, data, {
      headers: getHeaders()
    })
  },

  editarConvenio (id, data) {
    return axios.patch(`${API_BASE_URL}/convenios/${id}/`, data, {
      headers: getHeaders()
    })
  },

  cancelarConvenio (id) {
    return axios.post(`${API_BASE_URL}/convenios/${id}/cancelar/`, {}, {
      headers: getHeaders()
    })
  },

  vencerConvenio (id) {
    return axios.post(`${API_BASE_URL}/convenios/${id}/vencer/`, {}, {
      headers: getHeaders()
    })
  },

  reactivarConvenio (id) {
    return axios.post(`${API_BASE_URL}/convenios/${id}/reactivar/`, {}, {
      headers: getHeaders()
    })
  },

  eliminarConvenio (id) {
    return axios.delete(`${API_BASE_URL}/convenios/${id}/`, {
      headers: getHeaders()
    })
  },

  // ========== CAMPOS (COURSE AGREEMENTS) ==========

  listaCampos (params = {}) {
    return axios.get(`${API_BASE_URL}/course-agreements/`, {
      headers: getHeaders(),
      params
    })
  },

  getCampo (id) {
    return axios.get(`${API_BASE_URL}/course-agreements/${id}/`, {
      headers: getHeaders()
    })
  },

  crearCampo (data) {
    const isFormData = data instanceof FormData
    return axios.post(`${API_BASE_URL}/course-agreements/`, data, {
      headers: isFormData ? {
        'Authorization': `Token ${store.getters.getToken}`
      } : getHeaders()
    })
  },

  editarCampo (id, data) {
    const isFormData = data instanceof FormData
    return axios.patch(`${API_BASE_URL}/course-agreements/${id}/`, data, {
      headers: isFormData ? {
        'Authorization': `Token ${store.getters.getToken}`
      } : getHeaders()
    })
  },

  eliminarCampo (id) {
    return axios.delete(`${API_BASE_URL}/course-agreements/${id}/`, {
      headers: getHeaders()
    })
  },

  camposActivos () {
    return axios.get(`${API_BASE_URL}/course-agreements/active/`, {
      headers: getHeaders()
    })
  },

  camposPorClub (housingUnitId) {
    return axios.get(`${API_BASE_URL}/course-agreements/by_club/`, {
      headers: getHeaders(),
      params: { housing_unit: housingUnitId }
    })
  }
}
